// ============================================================
// HabitPack Theme System - V5
// Single-skin themes.
// 
// Source of truth: themes/[category]/[id]/theme.ts
// ============================================================

export * from './types'

import type { ThemeMeta, ThemePreset } from './types'
import { CATEGORY_META, getThemeVars } from './types'

import { GENERATED_THEME_PRESETS } from '@/themes/_generated/registry'

export const THEME_PRESETS: ThemePreset[] = GENERATED_THEME_PRESETS

const THEME_PRICE_OVERRIDE_BY_ID: Record<string, number> = {
  'core-protocol': 0,
}

const TIER_PRICE_FLOOR: Record<ThemePreset['tier'], number> = {
  common: 1575,
  rare: 2625,
  epic: 3675,
  legendary: 5250,
}

export function getThemeById(id: string): ThemePreset | undefined {
  return THEME_PRESETS.find((t) => t.id === id)
}

export function getCategoryMeta(category: ThemePreset['category']) {
  return CATEGORY_META.find((c) => c.id === category)
}

export function getAllCategories() {
  return CATEGORY_META
}

export function getThemeMeta(theme: ThemePreset): ThemeMeta {
  return {
    id: theme.id,
    name: theme.name,
    tagline: theme.tagline,
    category: theme.category,
    tier: theme.tier,
    basePrice: getEffectiveThemePrice(theme),
    swatches: theme.swatches,
    familyId: theme.familyId,
    variantName: theme.variantName,
  }
}

export function getAllThemeMeta(): ThemeMeta[] {
  return THEME_PRESETS.map(getThemeMeta)
}

export function getCompleteThemeVars(themeId: string): Record<string, string> | undefined {
  const theme = getThemeById(themeId)
  if (!theme) return undefined
  return getThemeVars(theme)
}

export function getEffectiveThemePrice(themeOrId: ThemePreset | string): number {
  const theme = typeof themeOrId === 'string' ? getThemeById(themeOrId) : themeOrId
  if (!theme) return 0

  const overridePrice = THEME_PRICE_OVERRIDE_BY_ID[theme.id]
  if (typeof overridePrice === 'number') return Math.max(0, overridePrice)

  const floor = TIER_PRICE_FLOOR[theme.tier] ?? 0
  return Math.max(0, Math.max(theme.basePrice, floor))
}


